import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http, settings } from "../../utils/config";

const initialState = {
  linkTiki: null,
  isLoadUrlTiki: false,
  token: null,
  isLoadToken: false,
  refreshTokenTiki: null,
  isLoadRefreshToken: false,
};

export const getUrlRedirectTiki = createAsyncThunk(
  "Tiki/getUrlRedirectTiki",
  async () => {
    const response = await http.get("/login-tiki");
    return response.data.data;
  }
);

export const getAccessTokenTiki = createAsyncThunk(
  "Tiki/getAccessTokenTiki",
  async (code) => {
    const response = await http.get(`/get-token-tiki?code=${code}`);
    return response.data.data;
  }
);

export const getRefreshTokenTiki = createAsyncThunk(
  "Tiki/getRefreshTokenTiki",
  async (refreshToken) => {
    const response = await http.post("/get-refresh-token-tiki", {
      refresh_token: refreshToken,
    });
    return response.data.data;
  }
);

const getUrlTiki = createSlice({
  name: "getUrlTiki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Auth URL
      .addCase(getUrlRedirectTiki.pending, (state) => {
        state.isLoadUrlTiki = true;
      })
      .addCase(getUrlRedirectTiki.fulfilled, (state, action) => {
        state.linkTiki = action.payload;
        state.isLoadUrlTiki = false;
      })
      .addCase(getUrlRedirectTiki.rejected, (state) => {
        state.isLoadUrlTiki = false;
      })
      // Token exchange
      .addCase(getAccessTokenTiki.pending, (state) => {
        state.isLoadToken = true;
      })
      .addCase(getAccessTokenTiki.fulfilled, (state, action) => {
        state.token = action.payload;
        state.isLoadToken = false;
        if (action.payload?.access_token) {
          settings.setCookie("access_tokenTiki", action.payload.access_token, 7);
        }
        if (action.payload?.refresh_token) {
          settings.setCookie("refresh_tokenTiki", action.payload.refresh_token, 30);
        }
      })
      .addCase(getAccessTokenTiki.rejected, (state) => {
        state.isLoadToken = false;
      })
      // Refresh token
      .addCase(getRefreshTokenTiki.pending, (state) => {
        state.isLoadRefreshToken = true;
      })
      .addCase(getRefreshTokenTiki.fulfilled, (state, action) => {
        state.refreshTokenTiki = action.payload;
        state.isLoadRefreshToken = false;
        if (action.payload?.access_token) {
          settings.setCookie("access_tokenTiki", action.payload.access_token, 7);
        }
        if (action.payload?.refresh_token) {
          settings.setCookie("refresh_tokenTiki", action.payload.refresh_token, 30);
        }
      })
      .addCase(getRefreshTokenTiki.rejected, (state) => {
        state.isLoadRefreshToken = false;
      });
  },
});

export default getUrlTiki.reducer;
